import {EventContextResponse} from "../types/tracking";
import {TRACK_LABEL} from "../types/constants";
import {SEARCH_BOX_ACTION} from "../types/sqrl/constants";
import {TrackingEvent} from "../events";

export class NavSlider {
  private _template: string = "";

  private saveHTMLTemplate(): string {
    const navSliderContainer = document.querySelector(".js_squirrel_navSliderContainer") as HTMLDivElement;
    navSliderContainer.removeAttribute("style");
    const template: string = navSliderContainer.outerHTML;
    navSliderContainer.outerHTML = "";
    return template;
  }

  get template(): string {
    if (!this._template) {
      this._template = this.saveHTMLTemplate();
    }
    return this._template;
  }

  onMergeEventContext(response: EventContextResponse) {
    const trackingData = { [TRACK_LABEL.SEARCH_BOX_ACTION]: SEARCH_BOX_ACTION.CLICK };
    TrackingEvent.addToMergeId(trackingData, response.eventMergeId);
  }
}

export const navSlider = new NavSlider();
